/* eslint-disable react/react-in-jsx-scope */
import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import GallerySection from '@/components/committee/GallerySection';
import { getContentList } from '@/lib/apiService';

const SpeakersLayout = () => {
  const [members22, setMembers22] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const prioritizedNames = [
    'Shri Amitabh Kant',
    'Dr. V. Anantha Nageswaran',
    'Shri N.K. Singh',
    'Shri K. Rajaraman',
    'Shri Pradeep Ramakrishnan',
    'Shri Jayant Sinha',
  ];

  useEffect(() => {
    getContentList('greenreturns_speakers', {
      limit: 100,
      sort: {
        sort_order: 'asc',
      },
    })
      .then((res) => {
        const speakers = res?.content?.data || [];

        // Sort speakers by priority first, then alphabetically
        const sortedSpeakers = speakers.sort((a, b) => {
          const indexA = prioritizedNames.indexOf(a.name);
          const indexB = prioritizedNames.indexOf(b.name);

          // If both names are in the priority list, sort by their index
          if (indexA !== -1 && indexB !== -1) return indexA - indexB;

          // If one name is in the priority list, it comes first
          if (indexA !== -1) return -1;
          if (indexB !== -1) return 1;

          // Otherwise, sort alphabetically by name
          return a.name.localeCompare(b.name);
        });
        // setMembers22(res?.content?.data as any);
        setMembers22(sortedSpeakers as any);
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
    setIsLoading(false);
  }, []);

  return (
    <Box width="100%" mb="10px">
      <Box bg="#197542" py="80px" w="100%">
        <Text
          fontWeight="700"
          fontSize={{ xs: '26px', md: '48px' }}
          lineHeight="130%"
          color="#fff"
          textAlign="center"
        >
          Speakers
        </Text>
      </Box>
      <Box mb="100px">
        {isLoading ? (
          <Center h="200px">
            <Spinner color="primary.500" />
          </Center>
        ) : (
          <GallerySection
            sort={false}
            data={members22}
            nameColor="#197542"
            slug_pattern="/greenReturns-2024/speakers/"
            columnNumberOnLg={5}
          />
        )}
      </Box>
    </Box>
  );
};

export default SpeakersLayout;
